import type { ReadonlyDeep } from 'type-fest';

import { BankInfoInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

export function bankInfoForm2ApiMapper(
  bankInfo: ReadonlyDeep<BankInfoInput>,
): ReadonlyDeep<BankInfoInput> {
  return pruneInput(bankInfo, BankInfoInput);
}
